export const VERDICT_STYLES = {
  TRUE: {
    label: "TRUE",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-500",
    iconColor: "text-emerald-600",
    dot: "bg-emerald-500",
  },
  FALSE: {
    label: "FALSE",
    bg: "bg-red-50",
    text: "text-red-700",
    border: "border-red-500",
    iconColor: "text-red-600",
    dot: "bg-red-500",
  },
  PARTIALLY_TRUE: {
    label: "PARTIAL",
    bg: "bg-amber-50",
    text: "text-amber-800",
    border: "border-amber-500",
    iconColor: "text-amber-600",
    dot: "bg-amber-500",
  },
  OUTDATED: {
    label: "OUTDATED",
    bg: "bg-sky-50",
    text: "text-sky-700",
    border: "border-sky-500",
    iconColor: "text-sky-600",
    dot: "bg-sky-500",
  },
  UNVERIFIABLE: {
    label: "UNVERIFIABLE",
    bg: "bg-stone-100",
    text: "text-stone-700",
    border: "border-stone-400",
    iconColor: "text-stone-600",
    dot: "bg-stone-500",
  },
  SATIRE: {
    label: "SATIRE",
    bg: "bg-violet-50",
    text: "text-violet-700",
    border: "border-violet-500",
    iconColor: "text-violet-600",
    dot: "bg-violet-500",
  },
};

export const TIER_STYLES = {
  1: {
    label: "T1 · Authoritative",
    text: "text-blue-700",
    border: "border-blue-500",
    bg: "bg-blue-50",
  },
  2: {
    label: "T2 · Wire/Fact-check",
    text: "text-violet-700",
    border: "border-violet-500",
    bg: "bg-violet-50",
  },
  3: {
    label: "T3 · Journalism",
    text: "text-emerald-700",
    border: "border-emerald-500",
    bg: "bg-emerald-50",
  },
};

export function getVerdictStyle(v) {
  return VERDICT_STYLES[v] || VERDICT_STYLES.UNVERIFIABLE;
}

export function getTierStyle(t) {
  return TIER_STYLES[t] || TIER_STYLES[3];
}
